import { useFormikContext } from "formik";
import { useEffect, useState } from "react";

export const FormikScrollToError = () => {
	const [lastSubmitCount, setLastSubmitCount] = useState(0);
	const { submitCount, isValid } = useFormikContext<Record<string, any>>();

	useEffect(() => {
		if (submitCount > lastSubmitCount && !isValid) {
			setLastSubmitCount(submitCount);

			const element = document.querySelectorAll('[aria-invalid="true"]')[0] as HTMLElement | undefined;

			if (element) {
				element.style.scrollMarginTop = "32px";
				element.scrollIntoView({ behavior: "smooth" });
				element.focus({ preventScroll: true });
			}
		}
	}, [isValid, lastSubmitCount, submitCount]);

	return null;
};
